module.exports = __webpack_public_path__ + "img/profile-tile-01.84aa3dae.jpg";